export default "__VITE_ASSET__gWR2e6Ha__"